// extracted by mini-css-extract-plugin
export default {"item":"list-compact-item-3RN54","itemText":"list-compact-itemText-3NJHu"};